module.exports = __webpack_public_path__ + "img/logo.ee8f7d9a.png";